<template>
  <div>
    <tabs space-around type="neutral" position="bottom" tab-nav-wrapper-classes="card-header-nav icon" tab-content-classes="tab-content-padding tab-no-space " v-model="activeTab">

      <!-- Recipes -->
      <tab-pane label="recipes">
        <template slot="label">
          <i class="fa fa-hamburger" @click="
            $store.commit('setState', {
              stateName: 'nutritionHomePageActiveTab',
              stateValue: 'recipes',
            })
          "></i>
          <span>{{ $t('message.Recipes') }}</span>
        </template>

        <div class="col-lg-8 pl-5 pr-5">
          <cool-select class="custom-input" :placeholder="$t('message.Search recipes')" :items="[]" v-model="selectedRecipe" @search="searchRecipe" @keyup="coolSelectOnKeyUp" :resetSearchOnBlur="false" ref="recipeSearch">
            <template #no-data>
              {{ "" }}
            </template>
          </cool-select>
        </div>

        <div class="col-12 recipe-list">
          <div class="row m-0 mt-4" v-if="breakfastRecipes.length">
            <div class="col-6">
              <h6 style="text-transform: none">{{ $t('message.Breakfast') }}</h6>
            </div>
            <div class="col-6" style="text-align:end;">
              <a class="text-primary" @click="ViewAllRecipes('breakfast')">
                <span>{{ $t('message.View all') }}</span><i class="fas fa-chevron-right ml-2"></i>
              </a>
            </div>
            <div class="col-12">
              <div class="row flex-nowrap pt-2 align-items-center" style="overflow-x: scroll">
                <div class="col-lg-3 col-7" v-for="breakfastRecipe in breakfastRecipes" :key="breakfastRecipe._id">
                  <card id="smoothie" class="rounded" @click.native="viewRecipe(breakfastRecipe)" card-body-classes="p-0">

                    <dynamic-image-background :file-id="breakfastRecipe.image">
                    </dynamic-image-background>

                    <div slot="footer">
                      <small>
                        {{ breakfastRecipe.name }}
                      </small>
                    </div>
                  </card>
                </div>

                <infinite-loading spinner="waveDots" @infinite="getBreakfastRecipes" class="col-1">
                  <span slot="no-more"></span>
                  <span slot="no-results"></span>
                </infinite-loading>

              </div>
            </div>
          </div>

          <div class="row m-0 mt-4" v-if="lunchRecipes.length">
            <div class="col-8">
              <h6 style="text-transform: none">{{ $t('message.Lunch') }}</h6>
            </div>
            <div class="col-4">
              <a class="text-primary" @click="ViewAllRecipes('lunch')">
                <span>{{ $t('message.View all') }}</span><i class="fas fa-chevron-right ml-2"></i>
              </a>
            </div>
            <div class="col-12 mt-2">
              <div class="row flex-nowrap pt-2 align-items-center" style="overflow-x: scroll">
                <div class="col-lg-3 col-7" v-for="lunchRecipe in lunchRecipes" :key="lunchRecipe._id">
                  <card id="smoothie" class="rounded" @click.native="viewRecipe(lunchRecipe)" card-body-classes="p-0">

                    <dynamic-image-background :file-id="lunchRecipe.image">
                    </dynamic-image-background>

                    <div slot="footer">
                      <small>
                        {{ lunchRecipe.name }}
                      </small>
                    </div>
                  </card>
                </div>

                <infinite-loading spinner="waveDots" @infinite="getLunchRecipes" class="col-1">
                  <span slot="no-more"></span>
                  <span slot="no-results"></span>
                </infinite-loading>

              </div>
            </div>
          </div>

          <div class="row m-0 mt-4 pt-2" v-if="dinnerRecipes.length">
            <div class="col-8">
              <h6 style="text-transform: none">{{ $t('message.Dinner') }}</h6>
            </div>
            <div class="col-4">
              <a class="text-primary" @click="ViewAllRecipes('dinner')">
                <span>{{ $t('message.View all') }}</span><i class="fas fa-chevron-right ml-2"></i>
              </a>
            </div>
            <div class="col-12 mt-2">
              <div class="row flex-nowrap pt-2 align-items-center" style="overflow-x: scroll">
                <div class="col-lg-3 col-7" v-for="dinnerRecipe in dinnerRecipes" :key="dinnerRecipe._id">
                  <card id="smoothie" class="rounded" @click.native="viewRecipe(dinnerRecipe)" card-body-classes="p-0">

                    <dynamic-image-background :file-id="dinnerRecipe.image">
                    </dynamic-image-background>

                    <div slot="footer">
                      <small>
                        {{ dinnerRecipe.name }}
                      </small>
                    </div>
                  </card>
                </div>

                <infinite-loading spinner="waveDots" @infinite="getDinnerRecipes" class="col-1">
                  <span slot="no-more"></span>
                  <span slot="no-results"></span>
                </infinite-loading>

              </div>
            </div>
          </div>
        </div>
      </tab-pane>

      <!-- Meal plan -->
      <tab-pane label="mealplan">
        <template slot="label">
          <i class="fa fa-calendar-day" @click="
            $store.commit('setState', {
              stateName: 'nutritionHomePageActiveTab',
              stateValue: 'mealplan',
            })
            "></i>
          <span>{{ $t('message.Meal Plan') }}</span>
        </template>

        <div class="col-12 p-0" v-if="checkDietPrescription" style="border-bottom: 1px solid #0000001f">
          <div class="d-flex" style="justify-content: space-around" v-if="this.dietPlan.type == 'weekly'">
            <div class=" text-center">
              <n-button type="primary" round icon :disabled="days.indexOf(selectedDay) == 0" simple style="border: none">
                <i class="fa fa-chevron-left"></i>
              </n-button>
            </div>

            <div class="text-center" style="white-space: nowrap; overflow: scroll" ref="day-selector">
              <n-button type="primary" round icon :id="day.date.getTime()" v-for="day in days" :key="day.date.getTime()" @click.native="selectDay(day)" :simple="selectedDay != day">
                {{ day.formattedDate }}
              </n-button>
            </div>

            <div class="text-center">
              <n-button type="primary" round icon @click.native="getSlotsForNextDay()" :disabled="days.indexOf(selectedDay) == days.length - 1" simple style="border: none">
                <i class="fa fa-chevron-right"></i>
              </n-button>
            </div>
          </div>
        </div>

        <div v-if="!checkDietPrescription" class="no-device-profile" style="text-align: center;">
          <h5 style="margin-top: 10vh;">{{ $t('message.No diet plan prescribed') }}</h5>
          <!-- <vitals-not-configured-svg style="height: 39vh; width: 63vw;"></vitals-not-configured-svg> -->
          <not-found-svg style="height: 39vh; width: 63vw;"></not-found-svg>
        </div>
        <n-button type="primary" round size="lg" @click.native="routeToConsultTab" style="
                top: auto;
                left: 50%;
                transform: translateX(-50%);
                bottom: 4rem;
                position: fixed;
                z-index: 999;
              ">
          {{ $t('message.Consult a Nutritionist') }}
        </n-button>

        <!-- meal plans  -->
        <div v-if="checkDietPrescription" class="">
          <time-line type="simple">
            <time-line-item v-for="(foodOptions, index) in mealPlanForDay" :key="index" v-if="foodOptions.foodOptions && foodOptions.foodOptions.length > 0" inverted :badge-type="'info'" :badge-icon="getBadgeIcon(index)">
              <h6 slot="header" style="font-weight: 600;color: black;">{{ index.toUpperCase() }} {{ foodOptions.time.absolute.startTime }}</h6>
              <div v-for="(foods, key) in foodOptions.foodOptions" :key="key" slot="content" style="display: flex; justify-content: space-between; margin-bottom: 1em;padding: 1em;border-radius: 24px; -webkit-box-shadow: 0 1px 15px 1px rgba(39, 39, 39, 0.1);box-shadow: 0 1px 15px 1px rgba(39, 39, 39, 0.1);">
                <div style="display: flex; flex-grow: 1;flex-direction: column;align-items: center;">
                  <div v-for="(meal, i) in foods" :key="i" @click="viewRecipeFromDish(meal._id)" style="display: flex;flex-direction: column;align-items: center;width: 100%;">
                    <div v-if="i === 1" style="text-align: center;border-radius: 10px;border-bottom: 1px solid gray;background-color: #d3d3d36e;padding: 0.5em;margin: 1.6em 0;width: fit-content;font-weight: 600;color: gray;">OR</div>
                    <div style="width: 100%;">
                      <div style="display: flex;gap: 1em;">
                        <i v-if="!setImage(meal._id)" style="font-size: 2em;border-radius: 25%;display: flex;align-items: center;justify-content: center;background-color: rgba(128, 128, 128, 0.21);width: 25%; max-width: 2em; height: max-content;padding: 0.5em 0.1em;" class="fa fa-utensils"></i>
                        <dynamic-image-background v-if="setImage(meal._id)" class="title-image" :file-id="setImage(meal._id)" style="width:25%;aspect-ratio: 1;border-radius: 25%;background-color: white;"></dynamic-image-background>
                        <div style="width: 75%;">
                          <div style="font-weight: 600;color: grey;">{{ meal.name }}</div>
                          <span>{{ meal.portion.value }} {{ meal.portion.unit }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-none">
                  <i class="fas fa-check-circle text-success fa-2x" v-if="true"></i>
                </div>
              </div>
            </time-line-item>
          </time-line>
        </div>
      </tab-pane>
      <!-- iconClass = "now-ui-icons ui-1_calendar-60"; -->

      <!-- Water Tracker -->
      <tab-pane label="watertracker">
        <template slot="label">
          <i class="fa fa-glass-whiskey" @click="
            $store.commit('setState', {
              stateName: 'nutritionHomePageActiveTab',
              stateValue: 'watertracker',
            })
          "></i>
          <span>{{ $t('message.Water Tracker') }}</span>
        </template>

        <div class="text-center watertracker" style="display: flex;flex-direction: column;color: grey;">
          <h6 style="z-index: 1">{{ $t('message.Target') }} {{ waterConsumptionTarget / 1000 }}L <span class="ml-3" @click="openSetTargetModal"><i class="fas fa-edit"></i></span></h6>

          <div class="cup" :style="{ backgroundPosition: -offsetX + 'rem ' + (offsetY + waterAnimationBgPositionYOffset) + 'rem' }" ref="waterSection">

            <div class="d-flex" style="margin-top: -13em">
              <div>
                <h1 style="font-size: 2.2em;">{{ waterConsumptionPercent }}</h1>
              </div>
              <div>
                %
              </div>
            </div>

            <div style="position: absolute;top: 0px;bottom: 0;">
              <img src="@/assets/img/human-stencil.png" style="filter: drop-shadow(0px 0px 2px black);height: 94%;box-shadow: 0px 0px 0px 50vw   white" />
            </div>

          </div>

          <div class="row controls pl-2 pr-2">
            <div class="col-4">
              <n-button type="primary" round @click.native="addWaterIntake(250)">
                +250 ml
              </n-button>
            </div>
            <div class="col-4">
              <n-button type="primary" round @click.native="addWaterIntake(500)">
                +500 ml
              </n-button>
            </div>
            <div class="col-4">
              <n-button type="primary" round @click.native="addWaterIntake(1000)">
                +1 L
              </n-button>
            </div>
          </div>

          <modal :show.sync="SHOW_WATER_TARGET_MODEL" footer-classes="justify-content-center">
            <div slot="header" style="margin-top:2em;">
              <h5 class="title title-up">{{ $t('message.Set Target') }}</h5>
            </div>
            <div class="set-water-target" v-if="SHOW_WATER_TARGET_MODEL">
              <div class="description-text">
                {{ $t('message.Set water target in ml') }}
              </div>
              <div>
                <el-input-number v-model="newWaterConsumptionTarget" step-strictly :step="250" :min="0" :max="10000"></el-input-number>

                <div class="mt-5 text-danger">
                  <span v-show="setWaterConsumptionTargetError"> {{ setWaterConsumptionTargetError }}</span>
                </div>
              </div>
            </div>
            <div slot="footer">
              <n-button type="primary" round @click.native="setWaterTarget">{{ $t('message.Save') }}</n-button>
            </div>
          </modal>
        </div>

      </tab-pane>
    </tabs>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import { TabPane, Tabs, Collapse, CollapseItem, Modal } from "src/components";
import avatarImage from "@/assets/img/proAvatar.png";
import Profile from "../Profile.vue";
import {
  StatsCard,
  Switch,
  TimeLine,
  TimeLineItem,
  Table as NTable,
  Checkbox,
} from "src/components";
import { DatePicker } from "element-ui";
import { CoolSelect } from "vue-cool-select";
import { Carousel, Slide } from "vue-carousel";
// import Vmaatu from "../../pages/simplemeetings/Vmaatu.vue";
// import WebexTeams from "../../pages/simplemeetings/WebexTeams.vue";

import swal from "sweetalert2";
import Message from "src/pages/carenation/Message.vue";
import socket from "@/services/socket";
import moment from "moment-timezone";
import CallNotification from "../../../components/CallNotification.vue";
import Bookings from "src/pages/carenation/Bookings.vue";
import consent from "../../../services/consent";
import Card from "../../../components/Cards/Card.vue";

import NotFoundSvg from "@/pages/carenation/components/svg_images/NotFoundSvg.vue";

export default {
  name: "home",

  components: {
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    StatsCard,
    [Switch.name]: Switch,
    TimeLine,
    TimeLineItem,
    CallNotification,
    NTable,
    Checkbox,
    [DatePicker.name]: DatePicker,
    Message,
    Modal,
    CoolSelect,
    Carousel,
    Slide,
    Bookings,
    Card,
    Profile,
    NotFoundSvg,
  },

  data() {
    return {
      imagesIds: {},
      days: [],
      selectedDay: null,
      dietPlan: null,
      mealPlanForDay: {},
      breakfastRecipes: [],
      breakfastRecipesPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      lunchRecipes: [],
      lunchRecipesPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      dinnerRecipes: [],
      dinnerRecipesPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      selectedRecipe: null,

      newWaterConsumptionTarget: 3000,
      waterConsumptionTarget: 3000,
      waterConsumption: 0,
      SHOW_WATER_TARGET_MODEL: false,
      offsetY: 35,
      offsetX: 15,
      setWaterConsumptionTargetError: "",
    };
  },

  computed: {

    checkDietPrescription() {
      if (this.dietPlan && this.dietPlan.type == "weekly") {
        if (this.dietPlan && this.dietPlan.weeklyPlan) {
          for (let a in this.dietPlan.weeklyPlan) {
            let Day = this.dietPlan.weeklyPlan[a]
            for (let timeOfDay in Day) {
              let meal = Day[timeOfDay]
              {
                if (meal && meal.foodOptions && meal.foodOptions.length) {
                  return true;
                }
              }
            }
          }
        }
        return false;
      }
      else {
        if (this.dietPlan && this.dietPlan.dailyPlan) {
          for (let timeOfDay in this.dietPlan.dailyPlan) {
            let meal = this.dietPlan.dailyPlan[timeOfDay];
            if (meal && meal.foodOptions && meal.foodOptions.length) {
              return true;
            }
          }
        }
        return false;
      }
    },
    waterConsumptionPercent() {
      return Math.round(
        (this.waterConsumption * 100) / this.waterConsumptionTarget
      );
    },
    waterAnimationBgPositionYOffset() {
      return (-this.offsetY * this.waterConsumptionPercent) / 100;
    },
    activeTab() {
      return this.$store.state.nutritionHomePageActiveTab;
    },
  },

  async mounted() {
    let curr = new Date();

    for (let i = 1; i <= 7; i++) {
      let first = curr.getDate() - curr.getDay() + i;
      let day = new Date(curr.setDate(first));
      this.days.push({
        date: day,
        formattedDate: moment(day).format("dd").charAt(0),
      });
    }

    let prescription = await this.$store.dispatch(
      "getPrescriptionByPatientId",
      {
        patientId: this.user.patientId,
      }
    );

    if (prescription) {
      this.dietPlan = prescription.prescriptions.dietPlan;

      if (this.dietPlan) {
        if (this.dietPlan.type == "weekly") {
          this.selectDay(this.days[0]);
        } else {
          this.mealPlanForDay = this.dietPlan.dailyPlan;
          this.getImage(this.mealPlanForDay);
        }
      }
    }

    if (this.user.waterConsumptionTarget) {
      this.waterConsumptionTarget = this.user.waterConsumptionTarget;
    }

    if (document.getElementsByClassName("main-panel")[0].offsetHeight < 670) {
      this.offsetY = 25.5;
      this.offsetX = 9;
    }

    await Promise.all([
      this.getBreakfastRecipes(),
      this.getLunchRecipes(),
      this.getDinnerRecipes(),
      this.getWaterConsumpionTracker(),
    ]);
  },

  methods: {
    getBadgeIcon(request) {
      let iconClass = "fa fa-utensils";
      switch (request) {
        case "bedTime":
          iconClass = "fas fa-glass-cheers";
          break;
        case "breakfast":
          iconClass = "fas fa-hamburger";
          break;
        case "dinner":
          iconClass = "fa fa-utensils";
          break;
        case "earlyMorning":
          iconClass = "fas fa-mug-hot";
          break;
        case "evening":
          iconClass = "fas fa-wine-glass-alt";
          break;
        case "lunch":
          iconClass = "fas fa-concierge-bell";
          break;
        case "midMorning":
          iconClass = "fas fa-cookie-bite";
          break;
      }
      return iconClass;
    },
    async getImage(mealPlanForDay) {
      let foodIds = [];
      for (let mealOfDay in mealPlanForDay) {
        if (mealPlanForDay.hasOwnProperty(mealOfDay)) {
          let meal = mealPlanForDay[mealOfDay];
          if (meal.foodOptions && meal.foodOptions.length > 0) {
            for (let foodOption of meal.foodOptions) {
              for (let food of foodOption) {
                if (food._id) {
                  foodIds.indexOf(food._id) === -1
                    ? foodIds.push(food._id)
                    : "";
                }
              }
            }
          }
        }
      }
      if (foodIds.length > 0) {
        let recipeImage = await this.$store.dispatch(
          "getRecipeImageFromDishId",
          foodIds
        );
        this.imagesIds = recipeImage;
      }
    },
    setImage(id) {
      if (this.imagesIds[id]) {
        return this.imagesIds[id];
      } else {
        return false;
      }
    },

    routeToConsultTab() {
      this.$store.commit("setState", {
        stateName: "homePageActiveTab",
        stateValue: "appointments",
      });
      this.$store.commit("setState", {
        stateName: "NutritionConsultation",
        stateValue: true,
      });
      this.$router.push({
        // patient home
        name: "message.Patient Home",
        params: { showCarecoDisclaimer: true },
      });
    },
    async viewRecipeFromDish(dishId) {
      try {
        if (dishId) {
          let recipe = await this.$store.dispatch(
            "getRecipeFromDishId",
            dishId
          );
          this.viewRecipe(recipe);
        } else {
          throw "No dish id";
        }
      } catch (error) {
        swal.fire({
          type: "error",
          title: "Recipe Not found",
          timer: 3000,
        });
      }
    },

    async getWaterConsumpionTracker() {
      let date = new Date();
      let waterTracker = await this.$store.dispatch(
        "getWaterConsumptionTraker",
        {
          userId: this.user._id,
          date,
        }
      );
      if (waterTracker) {
        this.waterConsumption = waterTracker.inTake.reduce((sum, curr) => {
          return sum + curr.amount;
        }, 0);

        if (this.waterConsumption) {
          if (this.waterConsumption > this.waterConsumptionTarget) {
            this.waterConsumption = this.waterConsumptionTarget;
          } else {
            this.waterConsumption = this.waterConsumption;
          }
        }
      }
    },
    async setWaterTarget() {
      this.setWaterConsumptionTargetError = "";

      if (this.newWaterConsumptionTarget < this.waterConsumption) {
        this.setWaterConsumptionTargetError =
          "Target quantity cannot be less than already consumed quantity";
        return;
      }

      let res = await this.$store.dispatch("setWaterConsumptionTarget", {
        userId: this.user._id,
        waterConsumptionTarget: this.newWaterConsumptionTarget,
      });
      if (res && res._id) {
        localStorage.user = JSON.stringify(res);
      }

      this.waterConsumptionTarget = res.waterConsumptionTarget;

      if (
        this.waterConsumption &&
        this.waterConsumption < this.waterConsumptionTarget
      ) {
        cordova.plugins.notification.local.getScheduled((res) => {
          for (let notification of res) {
            if (
              notification.data.normalize().replace(/"/g, "") ==
              "water notification"
            ) {
              cordova.plugins.notification.local.cancel(
                notification.id,
                (res) => {
                  console.log(res);
                }
              );
            }
          }
          this.setWaterTrackerNotification(new Date());
        });
      }
      this.SHOW_WATER_TARGET_MODEL = false;
    },

    setWaterTrackerNotification(date) {
      let times = [
        date.setHours(8, 0, 0),
        date.setHours(10, 0, 0),
        date.setHours(12, 0, 0),
        date.setHours(14, 0, 0),
        date.setHours(16, 0, 0),
        date.setHours(18, 0, 0),
        date.setHours(20, 0, 0),
        date.setHours(22, 0, 0),
      ];
      for (let time of times) {
        let id = 0;
        if (localStorage.remindersId) {
          id = Number(localStorage.remindersId);
        }
        cordova.plugins.notification.local.schedule({
          title: "Nutrition - Water Consumption Reminder",
          text: "Drink a glass of water",
          id: id,
          trigger: { at: time },
          foreground: true,
          autoClear: false,
          data: "water notification",
        });
        let waterTrackerNotificationsIds = [];
        if (localStorage.waterTrackerNotificationsIds) {
          waterTrackerNotificationsIds = JSON.parse(
            localStorage.waterTrackerNotificationsIds
          );
        }
        waterTrackerNotificationsIds.push(id);
        localStorage.waterTrackerNotificationsIds = JSON.stringify(
          waterTrackerNotificationsIds
        );
        id++;
        localStorage.remindersId = id;
      }
    },

    openSetTargetModal() {
      this.SHOW_WATER_TARGET_MODEL = true;
    },
    async addWaterIntake(quantity) {
      let that = this;
      await this.$store.dispatch("addWaterIntake", {
        amount: quantity,
        userId: this.user._id,
      });

      this.$refs.waterSection.classList.add("animate-water");

      setTimeout(() => {
        this.$refs.waterSection.classList.remove("animate-water");
      }, 2500);

      if (this.waterConsumption + quantity > this.waterConsumptionTarget) {
        this.waterConsumption = this.waterConsumptionTarget;
      } else {
        this.waterConsumption = this.waterConsumption + quantity;
      }

      if (this.waterConsumption) {
        if (this.waterConsumption >= this.waterConsumptionTarget) {
          cordova.plugins.notification.local.getScheduled((res) => {
            for (let notification of res) {
              if (
                notification.data.normalize().replace(/"/g, "") ==
                "water notification"
              ) {
                cordova.plugins.notification.local.cancel(
                  notification.id,
                  (res) => {
                    console.log(res);
                  }
                );
              }
            }
            // set water tracker for next day
            this.setWaterTrackerNotification(
              new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
            );
          });
        }
      }
    },
    ViewAllRecipes(recipeType) {
      this.$router.push({ path: "/veiwallrecipes/" + recipeType });
    },
    viewRecipe(recipe) {
      this.$store.commit("setState", {
        stateName: "recipe",
        stateValue: recipe,
      });
      this.$router.push("recipe");
    },
    selectDay(day) {
      let weekday = moment(day.date).format("dddd").toLowerCase();

      if (this.dietPlan) {
        this.mealPlanForDay = this.dietPlan.weeklyPlan[weekday];
      }

      this.selectedDay = day;
    },

    async getBreakfastRecipes($state) {
      try {
        if (!$state) {
          this.breakfastRecipes = [];
          this.breakfastRecipesPagination = {
            pageNumber: 1,
            totalPages: 0,
          };
        }

        let response = await this.$store.dispatch("getBreakfastRecipes", {
          pageNumber: this.breakfastRecipesPagination.pageNumber,
          pageSize: 3,
        });

        if (response.data && response.data.length) {
          this.breakfastRecipesPagination.totalPages = response.totalPages;
          this.breakfastRecipesPagination.pageNumber += 1;
          if ($state) {
            this.breakfastRecipes.push(...response.data);
            $state && $state.loaded();
          } else {
            this.breakfastRecipes = response.data;
          }
        } else {
          $state && $state.complete();
        }
      } catch (e) { }
    },

    async getLunchRecipes($state) {
      try {
        if (!$state) {
          this.lunchRecipes = [];
          this.lunchRecipesPagination = {
            pageNumber: 1,
            totalPages: 0,
          };
        }

        let response = await this.$store.dispatch("getLunchRecipes", {
          pageNumber: this.lunchRecipesPagination.pageNumber,
          pageSize: 3,
        });

        if (response.data && response.data.length) {
          this.lunchRecipesPagination.totalPages = response.totalPages;
          this.lunchRecipesPagination.pageNumber += 1;
          if ($state) {
            this.lunchRecipes.push(...response.data);
            $state && $state.loaded();
          } else {
            this.lunchRecipes = response.data;
          }
        } else {
          $state && $state.complete();
        }
      } catch (e) { }
    },

    async getDinnerRecipes($state) {
      try {
        if (!$state) {
          this.dinnerRecipes = [];
          this.dinnerRecipesPagination = {
            pageNumber: 1,
            totalPages: 0,
          };
        }

        let response = await this.$store.dispatch("getDinnerRecipes", {
          pageNumber: this.dinnerRecipesPagination.pageNumber,
          pageSize: 3,
        });

        if (response.data && response.data.length) {
          this.dinnerRecipesPagination.totalPages = response.totalPages;
          this.dinnerRecipesPagination.pageNumber += 1;
          if ($state) {
            this.dinnerRecipes.push(...response.data);
            $state && $state.loaded();
          } else {
            this.dinnerRecipes = response.data;
          }
        } else {
          $state && $state.complete();
        }
      } catch (e) { }
    },

    async searchBreakfastRecipes(searchString) {
      try {
        this.breakfastRecipes = await this.$store.dispatch("filterRecipes", {
          name: searchString,
          type: "breakfast",
        });
      } catch (e) { }
    },
    async searchLunchRecipes(searchString) {
      try {
        this.lunchRecipes = await this.$store.dispatch("filterRecipes", {
          name: searchString,
          type: "lunch",
        });
      } catch (e) { }
    },
    async searchDinnerRecipes(searchString) {
      try {
        this.dinnerRecipes = await this.$store.dispatch("filterRecipes", {
          name: searchString,
          type: "dinner",
        });
      } catch (e) { }
    },

    async searchRecipe(searchString) {
      this.recipeSearchQuery = searchString;
      if (searchString.length > 2) {
        await Promise.all([
          this.searchBreakfastRecipes(searchString),
          this.searchLunchRecipes(searchString),
          this.searchDinnerRecipes(searchString),
        ]);
      } else {
        await Promise.all([
          this.getBreakfastRecipes(),
          this.getLunchRecipes(),
          this.getDinnerRecipes(),
        ]);
      }
    },

    coolSelectOnKeyUp(event) {
      if (event.key == "Enter") {
        this.$refs.recipeSearch.$el.querySelector("input").blur();
      }
    },
  },
};
</script>

<style scoped>
.set-water-target .description-text {
  padding-bottom: 1em;
  padding-top: 2em;
}

.set-water-target {
  margin-bottom: 2em;
}

.controls button {
  width: 100%;
  /* border-radius: 1rem; */
}

.cup {
  height: 100%;
  color: grey;
  display: grid;
  place-items: center;
  position: relative;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background: url("../../../assets/img/wave.png");
  background-repeat: repeat-x;
  box-shadow: 0 0 0 6px #fff;
  background-size: cover;
}

.cup.animate-water {
  animation: filling 2.5s ease-in-out;
}

@keyframes filling {
  50% {
    background-position-x: 750px;
  }

  100% {
    background-position-x: 1500px;
  }
}

.recipe-list {
  padding-bottom: 10vh;
}

/deep/.recipe-list .card:not(.add-meal) {
  height: 12rem;
}

/deep/.recipe-list .card-body > div {
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
}

/deep/.recipe-list .card:not(.add-meal) hr {
  display: none;
}

.card.add-meal hr {
  margin: 0;
}

#home .stats {
  text-align: center;
}

.search-block {
  background-color: white;
  padding-top: 1em;
  padding-right: 2em;
  padding-left: 2em;
  margin-left: -2em;
  margin-right: -2em;
  padding-bottom: 6px;
}

.not-found-img {
  width: 100%;
}

.card-header-nav {
  background: var(--color-primary);
}

.card-header-nav .nav-pills > li > a > div {
  color: #fff;
}

.card-header-nav .nav-pills.nav-pills-neutral .nav-item .nav-link {
  background-color: transparent !important;
  box-shadow: none;
}

#home .tab-content.tab-subcategories {
  width: 100%;
}

.main-panel > .content {
  margin-top: 0px;
}

.icon .nav-link {
  padding: 0px 15px !important;
}

.tab-no-space {
  padding-top: 0px !important;
}
</style>

<style scoped>
#order-med-card {
  background-image: url("../../../assets/img/tablets-bg.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
}

#order-lab-card {
  background-image: url("../../../assets/img/labtest.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}

#get-help {
  background-image: url("../../../assets/img/medicalnurse.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position-x: right;
}

/deep/.cancel-appt-request-button {
  position: absolute;
  bottom: 4em;
  inset-inline-end: 50%;
  transform: translateX(50%);
}

[dir="rtl"] .cancel-appt-request-button {
  transform: translateX(-50%);
}

.video-call-wrapper {
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  inset-inline-end: 0px;
  height: 93vh;
  z-index: 1030;
  background-color: #f1f1f1;
}

.ios .video-call-wrapper {
  height: calc(100vh - 123px);
}

/deep/ .nav-pills .nav-item .nav-link {
  min-width: 64px;
}

#care-card-front,
.care-card-description {
  height: 18em;
}

.care-card-description {
  overflow: scroll;
}

.image-text-overlay {
  font-size: 0.7em;
}

.appointments-wrapper {
  margin-top: 1em;
}

.icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin: auto;
  margin-top: 8px;
  border-radius: 30%;
}

.icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 2.8;
  font-size: 25px;
}

.link-label {
  margin-top: 1em;
  display: block;
}

.link-section {
  margin-top: 0.5em;
  padding-top: 1.5em;
  border-top: 1px solid #dcd7d7;
}

/deep/ .tab-content {
  height: calc(100% - 68px);
  /* for fixed pagination from bottom */
  position: relative;
}

.content > div,
.content > div > div {
  height: 100%;
}

.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
}

.message-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.message-list:first-child {
  border-top: none;
}

.message-list.selected {
  background-color: whitesmoke;
}

.message-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}

.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}

.icon.icon-circle img {
  padding: 20px;
}

/deep/ .sc-chat-window {
  max-height: 100%;
  inset-inline-end: 0px;
  bottom: 0px;
  width: 100%;
  height: 78vh;
}

/deep/ .sc-message {
  width: 90%;
}

/deep/ .sc-header {
  display: none;
}

/deep/ .sc-launcher.opened {
  display: none;
}

/deep/ .VueCarousel-dot-container {
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot:focus {
  outline: none !important;
}

/deep/ .card-timeline .timeline > li {
  margin-bottom: 0px;
}

/deep/ .card-timeline .timeline > li > .timeline-badge {
  width: 36px;
  height: 36px;
  margin-left: -18px;
}

.boxes {
  --size: 32px;
  --duration: 800ms;
  height: calc(var(--size) * 2);
  width: calc(var(--size) * 3);
  position: relative;
  transform-style: preserve-3d;
  transform-origin: 50% 50%;
  margin-top: calc(var(--size) * 1.5 * -1);
  transform: rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px);
}

.boxes .box {
  width: var(--size);
  height: var(--size);
  top: 0;
  left: 0;
  position: absolute;
  transform-style: preserve-3d;
}

.boxes .box:nth-child(1) {
  transform: translate(100%, 0);
  animation: box1 var(--duration) linear infinite;
}

.boxes .box:nth-child(2) {
  transform: translate(0, 100%);
  animation: box2 var(--duration) linear infinite;
}

.boxes .box:nth-child(3) {
  transform: translate(100%, 100%);
  animation: box3 var(--duration) linear infinite;
}

.boxes .box:nth-child(4) {
  transform: translate(200%, 0);
  animation: box4 var(--duration) linear infinite;
}

.boxes .box > div {
  --background: #45b2fe;
  --top: auto;
  --inset-inline-end: auto;
  --bottom: auto;
  --left: auto;
  --translateZ: calc(var(--size) / 2);
  --rotateY: 0deg;
  --rotateX: 0deg;
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--background);
  top: var(--top);
  inset-inline-end: var(--right);
  bottom: var(--bottom);
  left: var(--left);
  transform: rotateY(var(--rotateY)) rotateX(var(--rotateX)) translateZ(var(--translateZ));
}

.boxes .box > div:nth-child(1) {
  --top: 0;
  --left: 0;
}

.boxes .box > div:nth-child(2) {
  --background: #369ae0;
  --inset-inline-end: 0;
  --rotateY: 90deg;
}

.boxes .box > div:nth-child(3) {
  --background: #aadcff;
  --rotateX: -90deg;
}

.boxes .box > div:nth-child(4) {
  --background: #dbe3f4;
  --top: 0;
  --left: 0;
  --translateZ: calc(var(--size) * 3 * -1);
}

@keyframes box1 {

  0%,
  50% {
    transform: translate(100%, 0);
  }

  100% {
    transform: translate(200%, 0);
  }
}

@keyframes box2 {
  0% {
    transform: translate(0, 100%);
  }

  50% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(100%, 0);
  }
}

@keyframes box3 {

  0%,
  50% {
    transform: translate(100%, 100%);
  }

  100% {
    transform: translate(0, 100%);
  }
}

@keyframes box4 {
  0% {
    transform: translate(200%, 0);
  }

  50% {
    transform: translate(200%, 100%);
  }

  100% {
    transform: translate(100%, 100%);
  }
}

html {
  -webkit-font-smoothing: antialiased;
}

* {
  box-sizing: border-box;
}

*:before,
*:after {
  box-sizing: border-box;
}

body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fbff;
}

body .dribbble {
  position: fixed;
  display: block;
  inset-inline-end: 20px;
  bottom: 20px;
}

body .dribbble img {
  display: block;
  height: 28px;
}

@media (min-width: 768px) {

  #care-card-front,
  .care-card-description {
    height: 24em;
  }
}

@media (min-width: 992px) {

  #care-card-front,
  .care-card-description {
    height: 22em;
  }
}

@media (max-height: 667px) {

  #care-card-front,
  .care-card-description {
    height: 11em;
  }
}

@media (min-height: 768px) {
  /deep/ .sc-chat-window {
    height: 74vh;
  }
}

@media (min-height: 1024px) {
  /deep/ .sc-chat-window {
    height: 81vh;
  }
}

.la-ball-scale-multiple,
.la-ball-scale-multiple > div {
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.la-ball-scale-multiple {
  display: block;
  font-size: 0;
  color: #fff;
}

.la-ball-scale-multiple.la-dark {
  color: #333;
}

.la-ball-scale-multiple > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.la-ball-scale-multiple {
  width: 32px;
  height: 32px;
}

.la-ball-scale-multiple > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  opacity: 0;
  -webkit-animation: ball-scale-multiple 1s 0s linear infinite;
  -moz-animation: ball-scale-multiple 1s 0s linear infinite;
  -o-animation: ball-scale-multiple 1s 0s linear infinite;
  animation: ball-scale-multiple 1s 0s linear infinite;
}

.la-ball-scale-multiple > div:nth-child(2) {
  -webkit-animation-delay: 0.2s;
  -moz-animation-delay: 0.2s;
  -o-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.la-ball-scale-multiple > div:nth-child(3) {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  -o-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.la-ball-scale-multiple.la-sm {
  width: 16px;
  height: 16px;
}

.la-ball-scale-multiple.la-sm > div {
  width: 16px;
  height: 16px;
}

.la-ball-scale-multiple.la-2x {
  width: 64px;
  height: 64px;
}

.la-ball-scale-multiple.la-2x > div {
  width: 64px;
  height: 64px;
}

.la-ball-scale-multiple.la-3x {
  width: 96px;
  height: 96px;
}

.la-ball-scale-multiple.la-3x > div {
  width: 96px;
  height: 96px;
}

/*
 * Animation
 */
@-webkit-keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  5% {
    opacity: 0.75;
  }

  100% {
    opacity: 0;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@-moz-keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -moz-transform: scale(0);
    transform: scale(0);
  }

  5% {
    opacity: 0.75;
  }

  100% {
    opacity: 0;
    -moz-transform: scale(1);
    transform: scale(1);
  }
}

@-o-keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -o-transform: scale(0);
    transform: scale(0);
  }

  5% {
    opacity: 0.75;
  }

  100% {
    opacity: 0;
    -o-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -o-transform: scale(0);
    transform: scale(0);
  }

  5% {
    opacity: 0.75;
  }

  100% {
    opacity: 0;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}

/deep/.tab-pane.active {
  overflow-x: hidden !important;
}

.watertracker {
  height: 81.3vh;
}

@media only screen and (max-height: 670px) {
  .watertracker {
    height: 79.5vh;
  }
}

/deep/.card-header-nav.icon {
  z-index: 200;
}

/deep/.card-timeline .timeline > li.timeline-inverted > .timeline-panel:before {
  display: none;
}

/deep/.card-timeline .timeline > li > .timeline-panel {
  -webkit-box-shadow: 0 2px 2px rgba(255, 255, 255, 0);
  box-shadow: 0 2px 2px rgba(255, 255, 255, 0);
  padding-left: 0px;
}

/deep/ .timeline-badge {
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .card-timeline .timeline-badge.info {
  background-color: var(--color-primary) !important;
}
</style>
